import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { EncroachmentTypeDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import { routeAnimations, ROUTE_ANIMATIONS_ELEMENTS } from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-encroachmenttype-container',
  templateUrl: './encroachmenttype-container.component.html',
  styleUrls: ['./encroachmenttype-container.component.scss']
})
export class EncroachmentTypeContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  encroachmenttypes$: Observable<EncroachmentTypeDto[]>;
  loading: boolean;
  isLoading$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoading$ = this.gatwayFacade.isLoadingGateway("EncroachmentType");
    this.encroachmenttypes$ = this.gatwayFacade.loadGateway("EncroachmentType");
    this.encroachmenttypes$.subscribe(data => {
      console.log("data: cont.",data);

    })
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteEncroachmentType(deletedValue: any) {
    this.gatwayFacade.remove("EncroachmentType", deletedValue);
    // this.store.dispatch(EncroachmentTypeStoreActions.removeEncroachmentType({ids: deletedValue}));
    this.notificationService.success('Deleted Successfully');
  }


// this method control both the create and update

  onSubmitEncroachmentType(formValue: any) {
    console.log("form value: ", formValue);
    formValue.EncroachmentTypes = formValue.EncroachmentTypes.reverse();
    event.preventDefault();
    const pullData = formValue.EncroachmentTypes;
    //const newPullData = formValue.EncroachmentTypees;

// declare two empty array to hold update and create data
  let allUpdates = [] ;
  let addAllEncroachmentType = [];


// loop through the form data to check for update and create

  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllEncroachmentType.push(pullData[i]);
    }
  }

// check if the addAllEncroachmentType array is not empty, then dispatch the data to the store
   if(addAllEncroachmentType.length !== 0) {
    this.gatwayFacade.add('EncroachmentType', addAllEncroachmentType);
    // this.store.dispatch(EncroachmentTypeStoreActions.addEncroachmentType({newEncroachmentType: addAllEncroachmentType}));

   }

// dispatch update data to the store
this.gatwayFacade.update('EncroachmentType', allUpdates, ['id']);
    // this.store.dispatch(EncroachmentTypeStoreActions.updateEncroachmentType({updateEncroachmentType: allUpdates}));
    this.notificationService.success('Saved Successfully');

  }

}


